import React from "react";
import { type FreefieldInputProps } from "../models";
import EmailInput from "components/ValidatedFields/WithErrorLabel/EmailInput";

const FreefieldEmail = (props: FreefieldInputProps & { validatorKey: string }) => {
  const [email, setEmail] = React.useState(props.initialValue ?? "");

  const onChange = (value: string) => {
    setEmail(value);
    props.onChange(value);
  };
  return <EmailInput
    validatorKey={props.validatorKey}
    value={email}
    onChange={onChange}
    emailCanBeBlank
  />;
};

export default FreefieldEmail;